module.exports = __webpack_public_path__ + "img/antes_despues_145.78456c41.png";